import { apiService } from "@/common/api.service.js";

export default {
  // Power BI dashboards
  powerBIDashboards() {
    const endpoint = `/api/nested-site-dashboards/`;
    return apiService(endpoint);
  },

  // EnergyEye dashboards
  energyEyeDashboards() {
    const endpoint = `/api/nested-energyeye-dashboards/`;
    return apiService(endpoint);
  },
};
